<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-md-12 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            data-toggle="modal"
            @click="instructionOpen">
            <app-icon name="book-open" />
          </button>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true && formType != ''">
        <div class="alert alert-info" role="alert">
          <button type="button" class="close" @click.prevent="instructionClose">
            <h5 aria-hidden="true">&times;</h5>
          </button>
          <h5 class="alert-heading"><app-icon name="book-open" /> {{$t("instructions_about_form_body_create")}}</h5>
          <p class="mb-0">{{$t("instructions_form_body_create")}}</p>
          <strong>Actions:</strong>
          <ul>
            <li><strong>{{ $t("save_form") }} :</strong> Saves the Form.</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
          <div class="form-group">
                <label>{{ $t("business_category") }}</label>
                <app-input
                  type="search-select"
                  :placeholder="$t('select_business_category')"
                  :list="categories"
                  v-model="category_id"
                  :required="true"
                />
              </div>
        </div>
    </div>
    <div id="formbuilderelement" class="formbuilderelement custom-scrollbar">
      <h3 class="ml-2" style="color:#000;">Form Elements</h3>
        <hr style="border-color:#000;" />
      <a style="color:#000" href="javascript:void(0)" class="closebtn" @click.prevent="closeNav()">&times;</a>
        <elements />
    </div>
    <el-container style="display: block !important">
      <div class="row">
        <div class="col-lg-2">
            <div class="row  p-1 "> 
              <div class="col-md-8 text-white btn-02 bg-primary">
                <p class="p-1 mt-3" style="font-size:11px;">Add Form Element</p>
              
              </div>
              <div class="col-md-4">
                <button class="btn btn-primary btn-style" @click.prevent="openNav()">
                  <i class="fa fa-plus icon" aria-hidden="true" style="color:#fff"></i>
                </button>
              </div>
            </div>
        </div>
        <div class="col-lg-8 custom-scrollbar" id="main" style="overflow-y: scroll;height: 80vh;">
          <!-- class="el-main-left" -->
          <el-main
            style="
              box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%),
                0 0 6px 0 rgb(0 0 0 / 4%);
            "
          >
            <div class="wrapper--forms">
              <el-form>
                <el-row>
                  <el-button
                    style="margin-bottom: 10px"
                    type="primary"
                    @click="addSection"
                    >Add Section</el-button
                  >
                </el-row>

                <el-row v-if="forms.length === 0">
                  <div class="empty-section">Please add Sections</div>
                </el-row>
                <!-- <div class="wrapper--snippet">
                  <pre>{{ forms }}</pre>
                </div> -->
                <template v-for="(eachFormObj, eachFormIndex) in forms">
                  <div :key="`div-${eachFormIndex}`" class="section-block">
                    <div class="source">
                      <el-row>
                        <el-col :span="18">
                          <el-input
                            placeholder="Please input section title"
                            v-model="eachFormObj.title"
                            style="width: 100%"
                          ></el-input>
                        </el-col>
                        <el-col :span="6">
                          <el-button
                            type="danger"
                            round
                            style="float: right"
                            @click=" deleteSection(eachFormIndex, eachFormObj.title) "
                          >
                            Delete Section
                          </el-button>
                        </el-col>
                      </el-row>
                    </div>
                    <div class="meta">
                      <el-row>
                        <draggable
                          :list="eachFormObj.fields"
                          class="dragArea"
                          :group="{
                            name: 'formbuilder',
                            pull: false,
                            put: true,
                          }"
                          :sort="true"
                          ghost-class="sortable__ghost"
                        >
                          <!-- The form elements starts (on the right) -->
                          <!-- <div> -->
                          <el-col
                              v-for="(field, index) in eachFormObj.fields"
                              :key="index"
                              v-bind="field"
                              :span="field.span"
                              class="form__group"
                              :class="{ 'is--active': field === activeField }"
                            >
                              <span class="form__selectedlabel">{{
                                field.fieldType
                              }}</span>

                              <div @click="editElementProperties(field)">
                                <!-- <label class="form__label" v-model="form.label" v-show="form.hasOwnProperty('label')">{{ form.label }}</label> -->
                                <component
                                  :is="field.fieldType"
                                  :currentField="field"
                                  class="form__field"
                                ></component>
                              </div>

                              <!-- Actions list -->
                              <div class="form__actiongroup">
                                <el-button
                                  circle
                                  size="mini"
                                  icon="el-icon-rank"
                                  class="form__actionitem--move"
                                ></el-button>

                                <el-button-group class="form__actionlist">
                              <el-tooltip
                                placement="top"
                                :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                                content="Duplicate">
                                  <el-button
                                    size="mini"
                                    icon="el-icon-plus"
                                    style="background-color:#9397a0;color:#fff"
                                    @click="
                                      cloneElement(
                                        index,
                                        field,
                                        eachFormObj.fields
                                      )
                                    "
                                    v-show="!field.isUnique"
                                  ></el-button>
                              </el-tooltip>
                              <el-tooltip
                                placement="top"
                                :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                                content="Properties">
                                  <el-button
                                    size="mini"
                                    icon="el-icon-setting"
                                    style="background-color:#000;color:#fff"
                                    class=""
                                    @click="
                                      openProperties();
                                    "
                                  ></el-button>
                              </el-tooltip>
                              <el-tooltip
                                placement="top"
                                :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                                content="Remove">
                                  <el-button
                                    size="mini"
                                    icon="el-icon-delete"
                                    style="background-color:red;color:#fff"
                                    class=""
                                    @click="
                                      deleteElement(index, eachFormObj.fields)
                                    "
                                  ></el-button>
                              </el-tooltip>
                                </el-button-group>
                              </div>
                            </el-col>
                          <!-- </div> -->
                        </draggable>
                      </el-row>
                    </div>
                  </div>
                </template>
              </el-form>
              <el-row v-if="saveStatus">
                <div class="d-flex justify-content-center">
                  <button
                    class="btn btn-success"
                    style="margin-bottom: 10px"
                    @click.prevent="saveForm">
                      Save Form
                  </button>
                </div>
              </el-row>
            </div>
          </el-main>
        </div>
        <div id="formbuilderproperties" class="formbuilderproperties custom-scrollbar">
          <h3 class="ml-2" style="color:#000;">Properties</h3>
        <hr style="border-color:#000;"/>
          <a style="color:#000" href="javascript:void(0)" class="closebtn" @click.prevent="closeProperties()">&times;</a>

          <div class="p-2">
            <properties
                    v-show="Object.keys(activeField).length > 0">
                    </properties>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
// import { FormBuilder } from "../../../form_elements/formbuilder";
// import { axiosPost } from "../../../../../../Helpers/AxiosHelper";
// import { FORM_BUILDER_POST } from "../../../../../../Config/ApiUrl";
import { FormBuilder } from "../../CustomFormBuilder/form_elements/formbuilder";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
import { PACKAGE_FORM_BUILDER_POST,CATEGORIES } from "../../../../Config/ApiUrl";

export default {
  name: "PackagesForm",
  props: {
    id: Number,
    closemodal: Function,
  },
  // store: ["forms", "activeField", "activeTabForFields"],
  data() {
    return {
      saveStatus: false,
      instructionShow: false,
      categories:[],
      category_id:'',
      form_id: 0,
      sortElementOptions: FormBuilder.$data.sortElementOptions,
      forms: this.$store.state.formBuilder.forms,
      // activeField: this.$store.state.formBuilder.activeField,
      // activeTabForFields: this.$store.state.formBuilder.activeTabForFields,
    };
  },
  mounted() {
    
    this.addSection();
    this.getCompanyCategories();
  },
  components: FormBuilder.$options.components,
  methods: {
    instructionOpen() {
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
    getCompanyCategories() {
      axiosGet(CATEGORIES)
        .then((res) => {
          this.categories = res.data;
        })
        .catch((error) => {
          
        });
    },
    deleteElement(index, form) {
      FormBuilder.deleteElement(index, form);
    },
    cloneElement(index, field, form) {
      FormBuilder.cloneElement(index, field, form);
    },
    editElementProperties(field) {
      
      
      FormBuilder.editElementProperties(field);
    },
    addSection() {
      const formObj = {
        title: "",
        fields: [],
        // form_id: this.id,
      };
      this.forms.push(formObj);
      this.saveStatus =  true;
    },
    saveForm() {
      this.package_id = this.id;
      if (this.category_id == '') {
        this.$toastr.e('Please Select Busniess Category');
      }
      else {
        axiosPost(PACKAGE_FORM_BUILDER_POST, {
        form: this.forms,
        id: this.package_id,
        category_id: this.category_id,
        })
          .then((res) => {
            this.$toastr.s(res.data.message);
            this.closemodal();
            $(".modal-backdrop").remove();
            //  $('.modal-backdrop').removeClass('fade');
          })
          .catch((res) => {
            console.error(res);
          });

      }
    },
    deleteSection(formIndex, formTitle) {
      this.$confirm(
        `Are you sure to delete the section ${formTitle}?`,
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        this.$delete(this.forms, formIndex);
      });
    },
    openNav() {
      this.instructionClose();
      $("#formbuilderelement").css("width", "250px");
      $("#main").css("margin-left", "230px");
    },
    closeNav() {
       $("#formbuilderelement").css("width", "0px");
       $("#main").css("margin-left", "0px");
    },
    openProperties(){ 
      this.instructionClose();
      $("#formbuilderproperties").css("width", "250px", 'margin-left', '400px');
      $("#main").css("margin-right", "400px");
    },
    closeProperties(){     
     $("#formbuilderproperties").css("width", "0px");
     $("#main").css("margin-right", "0px");

    }
  },
  computed: {
    activeField() {
      return this.$store.state.formBuilder.activeField;
    },
    activeTabForFields() {
      return this.$store.state.formBuilder.activeTabForFields;
    },
    theemMode() {
      return this.$store.state.theme;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.empty-section {
  text-align: center;
  font-size: 40px;
  background: linear-gradient(to bottom, #fff, #409eff);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
}
.dragArea {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  min-height: 10px;
  height: calc(30vh);
  z-index: 2;
}
.el-main-left {
  height: calc(90vh);
}
.form__selectedlabel {
  display: none;
  background: #ecf5ff;
  padding: 3px 5px;
  color: black;
  font-size: 10px;
  position: absolute;
  top: -17px;
  right: 15px;
}
.form__actionitem--move {
  position: absolute;
  right: -14px;
  top: 50%;
  transform: translateY(-50%);
  visibility: hidden;
  &:active,
  &:focus,
  &:hover {
    border-color: #409eff;
    background: #ecf5ff;
  }
}
.form__actionlist {
  position: absolute;
  margin-top: 10px;
  visibility: hidden;
  z-index: 3;
  right: 0;
  border-radius: 2px;
}
.form__group {
  margin-bottom: 25px;
  border: 1px solid transparent;
  position: relative;
  &:hover {
    border-color: #409eff;
    .form__actionitem--move {
      visibility: visible;
    }
  }
  &.is--active {
    border-color: #409eff;
    background: #ecf5ff;
    .form__actionlist {
      visibility: visible;
    }
    .form__selectedlabel {
      display: inline-block;
    }
  }
}
.section-block {
  border: 1px solid #ebebeb;
  border-radius: 3px;
}
.section-block .source {
  padding: 10px;
}
.section-block .meta {
  background-color: #fafafa;
  border-top: 1px solid #eaeefb;
}
.el-form-item {
  padding: 10px !important;
  margin-bottom: 0 !important;
}
.el-radio__inner {
  border-color: #dcdfe6 !important;
}

// Side Drawer
.formbuilderelement {
  height: 100%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 1; /* Stay on top */
  top: 80px; /* Stay at the top */
  left: 0;
  background-color: #f3f0f0; /* Black*/
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 60px; /* Place content 60px from the top */
  transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
}

.formbuilderproperties {
  height: 100%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 1; /* Stay on top */
  top: 80px; /* Stay at the top */
  right: 0;
  background-color: #f3f0f0; /* Black*/
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 60px; /* Place content 60px from the top */
  padding-bottom:100px;
  transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
}

.formbuilderproperties a{
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.formbuilderproperties .closebtn{
   position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
} 

/* The navigation menu links */
.formbuilderelement a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #fff;
  display: block;
  transition: 0.3s;
}


/* When you mouse over the navigation links, change their color */
.formbuilderelement a:hover {
  color: #f1f1f1;
}

/* Position and style the close button (top right corner) */
.formbuilderelement .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}
.btn-style{
  border-radius: 80px;
  padding:10px;
  margin-left: -65px;
  width: 50px;
  height: 50px;
}

.btn-02{
  border-radius: 80px;
}

/* Style page content - use this if you want to push the page content to the right when you open the side navigation */
#main {
  transition: margin-left .5s;
  // padding: 80px;
}

/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */
@media screen and (max-height: 450px) {
  .formbuilderelement {padding-top: 15px;}
  .formbuilderelement a {font-size: 18px;}
}





// side bar styling


.menu-wrapper {
    background-color: Tomato;
    position: absolute;
    top: 0;
    left: -100%;
    bottom: 0;
    width: 250px;
     /* overflow-y: auto;  */
}


.closeNavIcon-responsive {
    display: inline-block;
}

@keyframes move-sidebar {
    from {
        transform: translateX(-100%);
    }
    to {
        transform: translateX(0%);
    }
}

@keyframes move-sidebar-inside {
    from {
        transform: translateX(0%);
    }
    to {
        transform: translateX(-100%);
    }
}

.menu-wrapper.show {
    left: 0;
    animation: move-sidebar 1s cubic-bezier(.01,.87,.36,.99);
}

.menu-wrapper.hide {
    left: 0;
    animation: move-sidebar-inside 1s cubic-bezier(.01,.87,.36,.99) 1 normal forwards;
}

.menu {
    font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
    font-size: 16px;
}

.menu li {
    display: block;
    position: relative;
}

.menu li ul {
    background-color: #ec5539;
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
    height: 0;
}

.menu li.active>ul {
    height: initial;
}

.menu a {
    color: #DDD;
    text-decoration: none;
    padding: 10px 5px;
    display: block;
    position: relative;
}

.menu a:hover,
.menu a:hover>i:first-child,
.menu li.active>a,
.menu li.active>a i {
    background-color: gold;
    color: #000;
}

.menu a .cavet {
    position: absolute;
    right: 10px;
    transform: rotate(0deg);
    transition: transform 0.5s;
    display: inline-block;
    width: 20px;
}

.menu li.active>a .cavet {
    transform: rotate(90deg);
}

.menu li+li a {
    border-top: 1px solid #ec5539;
}

.menu a i {
    display: inline-block;
    padding-right: 10px;
    text-align: center;
    width: 20px;
    color: #fff;
}

.menu,
.menu ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

::selection {
    background-color: none;
}

/* menu animated icon */
.menu-icon, .menu-icon:before, .menu-icon:after{
    display: inline-block;
    background-color: rgb(255, 255, 255);
    height: 5px;
    width: 30px;
    transition: transform 0.5s cubic-bezier(.01,.87,.36,.99);
    transform-origin: left;
    border-radius: 2px;
}

.menu-icon:before, .menu-icon:after{
    content: "";
    position: absolute;
    left: 0;
}

.menu-icon{
    position: relative;
    transition: background-color 5;
    animation: fadeIn 1s cubic-bezier(.01,.87,.36,.99) 0s 1 normal forwards;
}

.menu-icon:before{
    top: 210%;
}

.menu-icon:after{
    bottom: 210%;
}

.menu-icon.active{
    animation: fadeOut 0.5s cubic-bezier(.01,.87,.36,.99) 0s 1 normal forwards;
}

@keyframes fadeOut{
    from{background-color: rgb(255, 255, 255);}
    to{background-color: rgba(255, 255, 255, 0);}
}

@keyframes fadeIn{
    from{background-color: rgba(255, 255, 255, 0);}
    to{background-color: rgb(255, 255, 255);}
}

.menu-icon.active:before{
    transform: rotate(-45deg);
}

.menu-icon.active:after{
    transform: rotate(45deg);
}

.menu-wrapper{

}

.menu-icon-wrapper{
    height: 40px;
    position: relative;
    top: 38px;
    width: 50px;
    background: Tomato;
    position: absolute;
    left: 100%;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
}

.menu-icon-wrapper a{
   margin-top: 18px;
   margin-left: 10px;
}


</style>